import React from 'react';
import { Container } from 'react-bootstrap';

function OurVision() {
  const captionStyleheader = {
    textAlign: 'center',
    padding: '2px',
    marginTop: '2rem',
    marginBottom: '4rem', // Adjusted for better spacing
  };

  const captionTextStyle = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '5rem',
    marginBottom: '2rem',
  };

  const captionTextStyle2 = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: 'black',
  };

  const captionTextStyle3 = {
    fontSize: '1.3rem',
    fontWeight: 600,
    textAlign: 'justify',
    lineHeight: '2.5', // Adjusted for better readability
    marginBottom: '2rem',
    padding:'20px',
    
  };

  return (
    <Container
    fluid
      style={{
        marginBottom: '10px',
        height: 'auto',
        marginTop: '10px',
      }}
    >
      <Container style={{ padding: '2px', ...captionStyleheader }}>
        <h1 style={captionTextStyle}>
          <span style={captionTextStyle2}>Our</span> Vision
        </h1>
        <p className="lead" style={captionTextStyle3}>
          <span style={{fontWeight: 700}}>Empowering the future of work: </span>
          Our vision is to be the leading force in connecting talent with opportunity, 
          fostering growth and innovation in the workforce. We aim to bridge skill gaps, cultivate thriving careers, 
          and enrich business globally by providing exceptional recruitment solutions, 
          leveraging technology and personalized services. As we grow, our commitment remains steadfast to enhancing local employment, 
          embracing global talent, and shaping a dynamic, diverse, and skilled workforce that propels industries forward.
        </p>
      </Container>
    </Container>
  );
}

export default OurVision;
